(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bolthero-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var groups = document.querySelectorAll('[data-bh-faq-group]');

    groups.forEach(function(group) {
      var items = group.querySelectorAll('[data-bh-faq-item]');

      items.forEach(function(item) {
        item.addEventListener('toggle', function() {
          if (item.open) {
            items.forEach(function(other) {
              if (other !== item && other.open) {
                other.open = false;
              }
            });
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
 class LmLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }
    if (!window.FloatingUIDOM) {
      await new Promise((r) => setTimeout(r, 500));

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button');
    const tooltip = elem.querySelector('.lm-tooltip');

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    }

    function showTooltip() {
      tooltip.classList.add('show');
      update();
    }

    function hideTooltip() {
      tooltip.classList.remove('show');
      tooltip.classList.add('hiding');
      setTimeout(() => {
        tooltip.classList.remove('hiding');
      }, 200);
    }

    const events = [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ];

    // Detect if the device is touch-capable
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip.classList.contains('show')) {
          hideTooltip();
        } else {
          showTooltip();
        }
      });

      // Hide the tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!elem.contains(e.target)) {
          hideTooltip();
        }
      });
    } else {
      events.forEach(([event, listener]) => {
        btn.addEventListener(event, listener);
      });
    }
  }
}

customElements.define('lumin-lookbook', LmLookBook);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-quote"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var buttons = document.querySelectorAll('[data-bh-scroll-top]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
